// extracted by mini-css-extract-plugin
export default {"container":"profile_container__o4QrS","profilepic":"profile_profilepic__WccGQ","label":"profile_label__TPfne","box":"profile_box__5wgps","profilebox":"profile_profilebox__9cC2z"};